/**
 * @fileOverview This file contains the implementation of the hook to manage the tour/tutorial in Technicians module.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { Typography } from "@mui/material";
import { useTranslationHook } from "../hooks/UseTranslationHook";

const useTechsTour = (setModalTShow) => {
  const {
    techsS1P1,
    techsS1P2,
    techsS2P1,
    techsS2P2,
    techsS3P1,
    techsS3P2,
    techsS3P3,
    techsS3P4,
    techsS3P5,
    techsS4P1,
    techsS4P2,
    techsS5P1,
    techsS5P2,
  } = useTranslationHook();

  return [
    {
      selector: ".create-tech-tour",
      content: (
        <Typography>
          <strong>{techsS1P1}</strong> {techsS1P2}
        </Typography>
      ),
      action: () => setModalTShow(false),
      stepInteraction: false,
    },
    {
      content: (
        <Typography>
          {techsS2P1} <strong>{techsS2P2}</strong>.
        </Typography>
      ),
      action: () => setModalTShow(true),
      stepInteraction: false,
    },
    {
      selector: ".create-tech-form-tour",
      content: (
        <Typography>
          {techsS3P1} <strong>{techsS3P2}</strong>. {techsS3P3}{" "}
          <strong>{techsS3P4}</strong> {techsS3P5}
        </Typography>
      ),
      action: () => setModalTShow(true),
      stepInteraction: false,
    },
    {
      selector: ".techs-datagrid-tour",
      content: (
        <Typography>
          {techsS4P1} <strong>{techsS4P2}</strong>.
        </Typography>
      ),
      action: () => setModalTShow(false),
      stepInteraction: false,
    },
    {
      selector: ".techs-datagrid-actions-tour",
      content: (
        <Typography>
          {techsS5P1} <strong>{techsS5P2}</strong>.
        </Typography>
      ),
      action: () => setModalTShow(false),
      stepInteraction: false,
    },
  ];
};

export default useTechsTour;
